import React from "react";

// Create a context to store scene-related references
export const SceneContext = React.createContext(null);
